import React, { useCallback, useEffect, useState } from 'react';
import { BaasicDraggable } from './BaasicDraggable.jsx';
import { BaasicCheckbox } from 'core/components/index.js';
import { observer } from 'mobx-react';

export const BaasicDraggableContainer = observer(
	({ t, reportEditViewStore: { columns, handleColumnsOrderChange, onSelectColumnCheckbox, onSelectColumn } }) => {
		const onMoveColumn = useCallback(
			(dragIndex, hoverIndex) => {
				handleColumnsOrderChange(dragIndex, hoverIndex);
			},
			[handleColumnsOrderChange]
		);

		const renderColumn = (column, index) => {
			return (
				<div className={`draggable__item + ${column.isActive ? 'is-active' : ''}`} key={column.columnKey}>
					<BaasicCheckbox
						id={column.columnKey}
						className={`input--check ${column.isPartiallySelected ? 'input--check--partially' : ''}`}
						checked={column.isSelected}
						onChangeCallback={() => onSelectColumnCheckbox(column)}
					/>

					<div className="draggable__dragg__wrap" onClick={async () => await onSelectColumn(column)}>
						<BaasicDraggable
							key={column.columnKey}
							index={index}
							id={column.columnKey}
							title={column.title}
							moveColumn={onMoveColumn}
						/>
					</div>
					<i className={`${column.isFilterable ? 'icon icon--sml icon--carret-left' : 'display--none'}`}></i>
				</div>
			);
		};

		return (
			<React.Fragment>
				<div className="table__settings__item first">{t('REPORTS.COLUMNS')}</div>
				<div className="table__settings__hold">{columns.map((column, i) => renderColumn(column, i))}</div>
			</React.Fragment>
		);
	}
);
